export default function generateBoard(boardSize, puzzles, characters) {
    let squaresNeeded = boardSize * boardSize;
    let board = new Array(squaresNeeded);
    
    let seededPuzzle = puzzles[Math.floor(Math.random() * puzzles.length)];
    let lastIndex = Math.floor(Math.random() * squaresNeeded);
    let alongX = true;
    seededPuzzle.solution.forEach(character => {
        alongX = !alongX;
        let available = [...Array(squaresNeeded).keys()];
        if (alongX) {
            available = available.filter(i => { return !board[i] && i % boardSize == lastIndex % boardSize});
        } else {		
            available = available.filter(i => { return !board[i] && Math.floor(i / boardSize) == Math.floor(lastIndex / boardSize)});
        }
        let selected = available[Math.floor(Math.random() * available.length)];

        if (!selected) return;
        board[selected] = { value: character, status: null };
        lastIndex = selected;
    });
    
    for (let i = 0; i < squaresNeeded; i++) {
        if (board[i]) continue;
        
        board[i] = { value: characters[Math.floor(Math.random() * characters.length)], status: null };
    }
    
    return board;
};